import type { AvatarMode } from '../../../types/customAvatar';
import type { AvatarLayerSelection } from '../../../types/user';
import { normalizeAvatarLayerSelection } from '../../../lib/avatarLayerSelection';

export const toHexColor = (value: unknown, fallback: string): string => {
  const candidate = String(value ?? '').trim();
  return /^#[0-9a-f]{6}$/i.test(candidate) ? candidate : fallback;
};

export const toTimestampDate = (value: unknown): Date | undefined => {
  if (!value || typeof value !== 'object') {
    return undefined;
  }

  const candidate = value as { toDate?: () => Date };
  if (typeof candidate.toDate !== 'function') {
    return undefined;
  }

  try {
    return candidate.toDate();
  } catch {
    return undefined;
  }
};

export const toAvatarMode = (value: unknown): AvatarMode =>
  value === 'custom' ? 'custom' : 'layers';

export const toOptionalString = (value: unknown): string | null => {
  const candidate = String(value ?? '').trim();
  return candidate.length > 0 ? candidate : null;
};

export const toAvatarLayerSelection = (value: unknown): AvatarLayerSelection | undefined => {
  return normalizeAvatarLayerSelection(value);
};
